import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class desAdminDecisionService {

  constructor(public http: HttpClient) { }

 

  public getUserDropdown(userId):Observable<any>{
    return this.http.get(environment.BASE_URL_DES+`desfAdmin/getAdminUsers/${userId}`)
  }

  
}
